import type { IBrandConfig } from './types';

const MEDICALSHIELD_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/privacy-policy',
  },
  termsOfService: { kind: 'cms', path: 'policy/tou/medical-shield-terms.md' },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  vaultProject: 'medical_shield',
  adaChat: true,
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'CyEx, LLC',
  licensor: 'cyex',
  carouselBanners: true,
  security: true,
  plan: true,
  finishSetup: true,
  hasCustomerServiceSupport: true,
  hidePhoneOnSignIn: true,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default MEDICALSHIELD_BRAND_CONFIG;
